export default "__VITE_ASSET__DGG00BE2__"